import { requests } from '../../../api/agent'

export default {
	createNews       : (params) => requests.post(`/News/CreateNews`, params),
	getNews          : (params) => requests.getWithParams(`/News/GetNews`, params),
	getOneNews       : (params) => requests.getWithParams('/News/GetOneNews', params),
	changeNews       : (params) => requests.post('/News/ChangeNews', params),
	deleteNews       : (params) => requests.getWithParams('/News/DeleteNews', params),
	downloadNewsFile : (params) => requests.getFile(`/News/downloadNewsFile`, params),
	restoreNews      : (params) => requests.getWithParams('/News/RestoreNews', params),
	getAllNews       : (params) => requests.getWithParams('/News/GetAllNewsPaged', params)
}